/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
// import alert from 'react-s-alert';
import * as c from './constant';

export const getRoleList = (
  payload = { is_paginated: 0, sort_by: 'desc' },
  callback
) => req.list(c.GET_ROLE, 'api/v1/administrators/roles', payload, callback);

export const createRole = (payload, callback) =>
  req.create(
    c.CREATE_ROLE,
    'api/v1/administrators/roles',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateRole = (id, payload, callback) =>
  req.update(
    c.UPDATE_ROLE,
    `api/v1/administrators/roles/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeRole = (id, payload, callback) =>
  req.remove(
    c.REMOVE_ROLE,
    `api/v1/administrators/roles/${id}`,
    payload,
    callback
  );

export const showRole = (id, payload, callback) =>
  req.item(
    c.GET_SELECTED_ROLE,
    `api/v1/administrators/roles/${id}`,
    payload,
    callback
  );

export const getPermissionList = (id, payload, callback) =>
  req.list(
    c.GET_PERMISSION,
    `api/v1/administrators/roles/${id}/permissions`,
    payload,
    callback
  );

export const createPermission = (id, payload, callback) =>
  req.create(
    c.CREATE_PERMISSION,
    `api/v1/administrators/roles/${id}/permissions`,
    payload,
    callback
  );

export const updatePermission = (id, selectedId, payload, callback) =>
  req.update(
    c.UPDATE_PERMISSION,
    `api/v1/administrators/roles/${id}/permissions/${selectedId}`,
    payload,
    callback
  );

export const removePermission = (id, selectedId, payload, callback) =>
  req.remove(
    c.REMOVE_PERMISSION,
    `api/v1/administrators/roles/${id}/permissions/${selectedId}`,
    payload,
    callback
  );

export const getListPermissions = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_LIST_PERMISSION,
    'api/v1/administrators/permissions',
    payload,
    callback
  );
